import { Instance, types } from 'mobx-state-tree';

import { getGroupsList } from '@common/api/curators';
import ChatGroup from '@common/models/ChatGroups/ChatGroup';
import TableData from '@common/models/TableData';

const ChatGroups = types
	.compose(
		TableData,
		types.model({
			data: types.optional(types.array(ChatGroup), []),
			service_id: types.maybe(types.number),
		}),
	)
	.named('ChatGroups')
	.actions((self) => ({
		_fetch: (query: any) => getGroupsList({ service_id: self.service_id, ...query }),
	}));

export default ChatGroups;

export interface IChatGroupsModel extends Instance<typeof ChatGroups> {}
